import { render } from "./SliderSteps.vue?vue&type=template&id=c3f3d4ca"
import script from "./SliderSteps.vue?vue&type=script&lang=js"
export * from "./SliderSteps.vue?vue&type=script&lang=js"

import "./SliderSteps.vue?vue&type=style&index=0&id=c3f3d4ca&lang=css"

import exportComponent from "C:\\Users\\Kevin\\Desktop\\ArbeitFinderundBeraterVersionen\\TvBerater\\FernseherBeraterUpdate05012026\\form_try0\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__